var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDashboard = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 97,
  height: 97,
  viewBox: "0 0 97 97",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M64.6562 16.167H72.7396C74.8834 16.167 76.9394 17.0186 78.4554 18.5345C79.9713 20.0505 80.8229 22.1065 80.8229 24.2503V80.8337C80.8229 82.9775 79.9713 85.0335 78.4554 86.5494C76.9394 88.0654 74.8834 88.917 72.7396 88.917H24.2396C22.0957 88.917 20.0397 88.0654 18.5238 86.5494C17.0079 85.0335 16.1563 82.9775 16.1562 80.8337V24.2503C16.1562 22.1065 17.0079 20.0505 18.5238 18.5345C20.0397 17.0186 22.0957 16.167 24.2396 16.167H32.3229",
  stroke: "#ffffff",
  strokeWidth: 6.91667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M60.6354 8.08203H36.3854C34.1533 8.08203 32.3438 9.89155 32.3438 12.1237V20.207C32.3438 22.4392 34.1533 24.2487 36.3854 24.2487H60.6354C62.8676 24.2487 64.6771 22.4392 64.6771 20.207V12.1237C64.6771 9.89155 62.8676 8.08203 60.6354 8.08203Z",
  stroke: "#ffffff",
  strokeWidth: 6.91667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDashboard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dashboard.686d6d3f549a00e443cae13b913301b5.svg";